import { Post, Delete, Get } from "./common";

export default class FollowService {
  static follow = async (token: string, sellerId: string) =>
    await Post({ path: "follows/", token, body: { sellerId } });

  static unfollow = async (token: string, sellerId: string) =>
    await Delete({ path: `follows/${sellerId}`, token });

  static getFollowing = async (token: string) =>
    await Get({ path: "follows/", token });

  static getAds = async (token: string, data: any) =>
    await Post({ path: "follows/ads", token, body: data });

  static getFollowers = async (token: string, data: any) =>
    await Post({ path: "follows/followers", token, body: data });

  static getFollowingList = async (token: string, data: any) =>
    await Post({ path: "follows/following-list", token, body: data });
}
